import React, {useEffect} from "react";
import {useSelector} from "react-redux";
import Cloud from "../../Cloud/Cloud";
import {setAutoDir, setWasInMiniCloud} from "../../../../../_reducers/cloudSlice";
import useTaggedDispatch from "../../../../../hooks/useTaggedDispatch";

const EditSupplierCloud = ({tabKey}) => {
    const dispatch = useTaggedDispatch({tabKey});
    const editSupplier = useSelector((state) => state.SUPPLIERS_DATA.editSupplier[tabKey]);

    useEffect(() => {
        dispatch(setWasInMiniCloud(true));
        dispatch(setAutoDir(`/ERP/Προμηθευτές/${editSupplier._id}`));
    }, []);

    return (
        <React.Fragment>
            <Cloud miniCloud={true} />
        </React.Fragment>
    )
}

export default EditSupplierCloud;
